module.exports = __webpack_public_path__ + "assets/img/form.2e81062d.png";